module.exports = __webpack_public_path__ + "static/media/vehicle-small.97f0d326.svg";